export const SKU_SEPARATOR = '|.|'
export const EMAIL_PATTERN = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)